import { currencySymbolMap, LocalEum } from '@/constant'
import { EditConfigType, LangEum, LangMapType } from '@/typings/types'
import { useMemo } from 'react'

/**
 * 组件级
 * @param props
 */
export default function useLangConfig<T>(props: {
  editConfig: EditConfigType
  langConfigMap: LangMapType<T>
}) {
  const { langConfigMap, editConfig } = props

  const lang = useMemo(() => editConfig?.lang || LangEum.en, [editConfig?.lang])

  const currencyCode = useMemo(() => {
    return currencySymbolMap[editConfig?.local] || LocalEum.HK
  }, [editConfig?.local])

  const langConfig = useMemo(() => {
    const nextLang = langConfigMap[lang] || langConfigMap.en
    return nextLang
  }, [langConfigMap, lang])

  return { langConfig, lang, currencyCode }
}
